import { Suspense } from "react";
import { Toaster } from "sonner";
import Loader from "@/components/loader";
import Providers from "./components/providers";
import RoutingSystem from "./routing-system";

const App = () => {
 return (
     <Suspense fallback={<Loader />}>
       <Providers>
         <RoutingSystem />
         <Toaster />
       </Providers>
     </Suspense>
   );
};

export default App;
